import { db, usersCollection } from "./firebase"; // Ensure firebase.js exports the Firestore instance

// Helper function to fetch all users from Firestore
export const fetchUsers = async () => {
  try {
    const snapshot = await db.collection("users").get();
    const users = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    return users;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw new Error("Failed to fetch users.");
  }
};


export const fetchUserById = async (id) => {
  if (!id) throw new Error("User ID is required");

  const userDoc = await usersCollection.doc(id).get();
  if (!userDoc.exists) {
    throw new Error("User not found");
  }

  return { id: userDoc.id, ...userDoc.data() };
};

// Helper function to find user details by email
export const fetchUserDetails = async ({ queryKey }) => {
  const [, email] = queryKey;
  if (!email) throw new Error("Email is required to fetch user details.");

  try {
    const snapshot = await db.collection("users").where("email", "==", email).get();
    if (snapshot.empty) throw new Error(`User with email ${email} not found.`);
    
    const user = snapshot.docs[0].data();
    return {
      fullName: `${user.firstName} ${user.surname}`,
      email: user.email,
      role: user.role,
      serviceGroup: user.serviceGroup,
      userAccess: user.userAccess || false,
      savedFilters: user.savedFilters || [],
    };
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

// Helper function to fetch user permissions by email
export const fetchUserPermissions = async ({ queryKey }) => {
  const [, email] = queryKey;
  if (!email) throw new Error("Email is required to fetch permissions.");

  try {
    const snapshot = await db.collection("users").where("email", "==", email).get();
    if (snapshot.empty) throw new Error(`User with email ${email} not found.`);
    
    const user = snapshot.docs[0].data();
    return { permissions: user.permissions };
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    throw error;
  }
};
